import React, { useState } from 'react';
import AccountContainer from '../../../components/AccountContainer';
import subscriptionSideMenuItems from './subscriptionSideMenuItems';
import TripOverview from './TripOverview';
import SelectTripComponent from './SelectTripComponent';
import { useJsonApi } from '../../../services/GlobalStore/GlobalStore';
import useAuthenticate from '../../../hooks/useAuthenticate';
import BuySubscription from './BuySubscription';
import Loading from '../../../components/Loading';
import CreditBanner from './CreditBanner';
import LoungeAccess from './LoungeAccess/LoungeAccess';

const Premium = () => {
  const [addTrip, setAddTrip] = useState<boolean>(false);
  const { token } = useAuthenticate();

  const { data: flightsData, loading: subscriptionLoading } = useJsonApi(
    `/subscriptions`,
    {
      cachePolicy: 'no-cache',
      queryParams: {
        include: [
          'subscriptionTrips',
          'subscriptionTrips.subscriptionFlights.airline',
          'subscriptionTrips.subscriptionFlights.departureAirport',
          'subscriptionTrips.subscriptionFlights.arrivalAirport',
          'subscriptionTrips.subscriptionFlights.lounges',
          'currentSubscriptionBillingCycle',
        ].join(),
      },
      headers: { Authorization: `Bearer ${token}` },
    },
    []
  );

  return (
    <>
      {flightsData?.[0]?.stripe_status === 'active' && !subscriptionLoading ? (
        <AccountContainer menuItems={subscriptionSideMenuItems}>
          {!addTrip ? (
            <div className="flex flex-col" style={{ gap: '28px' }}>
              <TripOverview setAddTrip={setAddTrip} data={flightsData} />
              <LoungeAccess data={flightsData} />
              <CreditBanner data={flightsData} />
            </div>
          ) : (
            addTrip && <SelectTripComponent setAddTrip={setAddTrip} />
          )}
        </AccountContainer>
      ) : flightsData?.[0]?.stripe_status !== 'active' &&
        !subscriptionLoading ? (
        <BuySubscription />
      ) : (
        <div
          className="flex items-center align-center justify-center"
          style={{ height: '100vh' }}
        >
          <Loading />
        </div>
      )}
    </>
  );
};

export default Premium;
